module.exports = __webpack_public_path__ + "img/ou.c369e214.png";